import React, { useEffect } from "react";
import { Formik, FieldArray, Form } from "formik";
import SelectBox from "../../../../src/components/forms/SelectBox";
import NumberIncrement from "../../../../src/components/forms/NumberIncrement";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { updateProperty } from "@/_actions/propertiesActions";
import getAcquisitionToken from "../../../../src/utils/getAcquisitionToken";
import { RefreshIcon } from "@heroicons/react/solid";

const amenitiesArray = [
  { value: "30", name: "Aire Acondicionado" },
  { value: "31", name: "Alberca" },
  { value: "32", name: "Amueblado" },
  { value: "121", name: "Coto" },
  { value: "10", name: "Cuarto de Servicio" },
  { value: "46", name: "Estudio" },
  { value: "50", name: "Jacuzzi" },
  { value: "14", name: "Oficina" },
  { value: "73", name: "Roof Garden" },
];

export default function AmenitiesForm() {
  const history = useNavigate();
  const setAmenities = (checked, value, amenities, arrayHelpers) => {
    if (checked) {
      arrayHelpers.push(value);
    } else {
      const i = amenities.indexOf(value);
      arrayHelpers.remove(i);
    }
  };
  useEffect(() => {
    const token = getAcquisitionToken();
    if (!token) {
      history("/unirse/particular");
    }
    if (!localStorage.getItem("CYTpropertyUuid")) {
      history("/unirse/ubicacion-precio");
    }
  }, []);

  const onSubmit = async (values, actions) => {
    const { setSubmitting } = actions;
    setSubmitting(true);
    try {
      await updateProperty(localStorage.getItem("CYTpropertyUuid"), values);
      setSubmitting(false);
      history("/unirse/descripcion");
    } catch (err) {
      setSubmitting(false);
      Sentry.captureException(err);
    }
  };

  return (
    <Formik
      initialValues={{
        amenities: [],
        rooms: 0,
        bathrooms: 0,
        half_bathrooms: 0,
      }}
      onSubmit={onSubmit}
      render={({ values, isSubmitting }) => (
        <Form className="relative w-full space-y-3">
          <FieldArray
            name="amenities"
            render={(arrayHelpers) => (
              <div className="w-full grid-cols-2 gap-3 space-y-3 overflow-y-auto md:grid md:space-y-0">
                {amenitiesArray.map((amenity) => (
                  <>
                    <SelectBox
                      option={amenity}
                      callBack={(checked, value) =>
                        setAmenities(
                          checked,
                          value,
                          values.amenities,
                          arrayHelpers
                        )
                      }
                    />
                  </>
                ))}
              </div>
            )}
          />
          <div className="space-y-3">
            <NumberIncrement name="rooms" label="Habitaciones" />
            <NumberIncrement name="bathrooms" label="Baños" />
            <NumberIncrement name="half_bathrooms" label="Medios Baños" />
          </div>
          <div className="col-span-2 mt-3 w-full bg-white p-4 md:block md:p-0">
            <div
              className="mb-10 hidden  items-center md:flex"
              aria-hidden="true"
            >
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="sticky bottom-0 z-50 grid w-full grid-cols-2 bg-white p-3 md:relative md:bg-transparent md:p-5">
              <a
                href="/unirse/ubicacion-precio"
                className="self-center underline"
              >
                Regresar
              </a>
              <div className="sticky bottom-0 bg-white p-2 pb-7 md:block md:p-0">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="group relative flex w-full justify-center rounded-md border border-transparent bg-black py-2 px-4 text-lg font-medium text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  {isSubmitting ? (
                    <div className="flex items-center justify-center">
                      <RefreshIcon
                        className="mr-2 h-5 w-5 animate-spin"
                        aria-hidden="true"
                      />
                      <span className="ml-2">Procesando...</span>
                    </div>
                  ) : (
                    <>
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <svg
                          className="h-5 w-5 text-black group-hover:text-black"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                      Continuar
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    />
  );
}
